export const urlEncodeSearchQuery = (searchQuery: string) => {
  return encodeURIComponent(searchQuery)?.replace(/%20/g, '+')
}
